import Events from '../Pages/Events/Events';
import Dashboard from '../Pages/Dashboard/Dashboard';
import CreateUsers from '../Pages/CreateUsers/CreateUsers';
import Users from '../Pages/Users/Users';
import TeamsOverview from '../Pages/TeamsOverview/TeamsOverview';
import AddNewEvent from '../Pages/AddNewEvent/AddNewEvent';
import { DeletedEventsTable } from '../Components/ProfileNav/Bin/DeletedEventsTable';
import { DeletedSubscribersTable } from '../Components/ProfileNav/Bin/DeletedSubscribersTable';
import TeamEvents from '../Components/TeamEvents/TeamEvents';
import EventDetails from '../Components/EventDetails/EventDetails';
import HCPMasterData from '../Pages/HCPMasterData/HCPMasterData';
import SpendTypes from '../Pages/SpendTypes/SpendTypes';
import ActivityTypes from '../Pages/ActivityTypes/ActivityTypes';
import EventTypes from '../Pages/EventTypes/EventTypes';
import Divisions from '../Pages/Divisions/Divisions';
import Teams from '../Pages/Teams/Teams';
import Organizations from '../Pages/Organizations/Organizations';
import Relationships from '../Pages/Relationships/Relationships';
import ExternalSources from '../Pages/ExternalSources/ExternalSources';
import Roles from '../Pages/Roles/Roles';
import Countries from '../Pages/Countries/Countries';
import Cities from '../Pages/Cities/Cities';
import Brands from '../Pages/Brands/Brands';
// import SessionExpirationDemo from '../Components/SessionExpiration/SessionExpirationDemo';

export const routes = [
  {
    path: '/',
    element: <Dashboard />,
  },
  {
    path: '/events',
    element: <Events />,
  },
  {
    path: '/teams-overview',
    element: <TeamsOverview />,
  },
  {
    path: "team-events",
    element: <TeamEvents />,
  },
  {
    path: '/users',
    element: <Users />,
  },
  {
    path: '/users/create',
    element: <CreateUsers />,
  },
  {
    path: '/add-event',
    element: <AddNewEvent />,
  },
  // {
  //   path: '/register',
  //   element: <RegistrationLayout />,
  // },
  {
    path: "/deleted-events",
    element: <DeletedEventsTable />
  },
  {
    path: "/deleted-subscribers",
    element: <DeletedSubscribersTable />
  },
  {
    path: "/event-details/:eventId",
    element: <EventDetails />
  },
  {
    path: "/hcp-master-data",
    element: <HCPMasterData />
  },
  {
    path: "/countries",
    element: <Countries />
  },
  {
    path: "/cities",
    element: <Cities />
  },
  {
    path: "/spend-types",
    element: <SpendTypes />
  },
  {
    path: "/activity-types",
    element: <ActivityTypes />
  },
  {
    path: "/event-types",
    element: <EventTypes />
  },
  {
    path: "/divisions",
    element: <Divisions />
  },
  {
    path: "/teams",
    element: <Teams />
  },
  {
    path: "/organizations",
    element: <Organizations />
  },
  {
    path: "/relationships",
    element: <Relationships />,
  },
  {
    path: "/external-sources",
    element: <ExternalSources />,
  },
  {
    path: "/roles",
    element: <Roles />
  },
  {
    path: "/brands",
    element: <Brands />
  },
  // {
  //   path: "/session-demo",
  //   element: <SessionExpirationDemo /> // Keep this for testing
  // }
];